import { apiClient, apiGet, apiPost, apiDelete } from "@/lib/api/client";

const BASE = "/reactions";

export const reactionsApi = {
  react: (targetType: string, targetId: string, reaction: string) =>
    apiPost<{ reaction: Record<string, unknown> }>(BASE, { targetType, targetId, reaction }),

  unreact: (targetType: string, targetId: string, reaction: string) =>
    apiDelete<{ message: string }>(`${BASE}/${targetType}/${targetId}/${reaction}`),

  getReactions: (targetType: string, targetId: string) =>
    apiGet<{ reactions: Record<string, unknown>[] }>(`${BASE}/${targetType}/${targetId}`),
};
